import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import UserInfo from '../../../components/ProfilePage/UserInfo';

const mapStateToProps = (state: StoreState) => {
	const {
		profile: {
			name,
			email,
			position,
			phone,
		},
	} = state;

	return {
		name,
		email,
		position,
		phone,
	};
};

export default connect(mapStateToProps)(UserInfo);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/UserInfo/index.tsx